<template>
  <div class="km__modules__pattern--colortips">
    <ul class="km__list--modules">
      <li class="km__list__element--modules color-tips" v-for="(colortip, index) in farbvorschlaege" :key="index">
        <div class="km__button--pattern"
             @click="$emit('colortip_clicked', colortip)"
        >
          <img
              :src="'https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=132'+previewImagepath(colortip.id)"
              :srcset="getSrcSet(colortip.id)"
              alt="colortip">
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {watch} from "vue";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const props = defineProps({
  farbvorschlaege: Array,
  logo_id: Number
});

const store = useStore();
const animation = AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation(".km__modules__pattern--colortips");
const keyFrames = new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 0, opacity: 0});
const openStatusStore = useModuleColorOpenStateStore();
watch(() => openStatusStore.getPatternFarbVorschlaegeState, newValue => animation(keyFrames.getTarget(newValue)));
const previewPath = id => id.toString().slice(-2)
const previewImagepath = colorTipId => '/logodatenbank/' + previewPath(props.logo_id) + '/' + props.logo_id + '_' + colorTipId + '_big.png';


const getSrcSet = colorTipID => {
  const s = previewImagepath(colorTipID);
  return "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=132" + s + " 1x," +
      "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=198" + s + " 1.5x, " +
      "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=264" + s + "2x"
};

</script>

<style scoped lang="scss">
.km__modules__pattern--colortips {
  position: fixed;
  height: 79px;
  width: 100%;
  right: -100%;
  bottom: calc(52px + #{$cta-height});
  z-index: 999;
  overflow-y: hidden;
  opacity: 0;

  .km__list--modules {
    position: relative;
    overflow-x: scroll;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    flex-direction: row;
    padding-bottom: 115px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-auto-flow: column;

    &.color-tips {
      padding-top: 43px;
    }

    .km__list__element--modules {
      padding: 6px 7px;
    }

    .km__button--pattern {
      overflow: hidden;

      img {
        position: relative;
        top: -5px;
      }
    }
  }
}
</style>
